import {
  FETCH_REWARDS_POINTS_REQUEST,
  FETCH_REWARDS_POINTS_SUCCESS,
  FETCH_REWARDS_POINTS_FAILURE,
  RESET_REWARDS_POINTS,
} from "../actionTypes";

const initialState = {
  data: [],
  isLoading: false,
  message: "",
  status: false,
};

const fetchRewardsPointsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REWARDS_POINTS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_REWARDS_POINTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        status: action.payload.status,
      };
    case FETCH_REWARDS_POINTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        data: [],
        message: action.payload.message,
        status: action.payload.status,
      };
    case RESET_REWARDS_POINTS: // Reset message action
      return {
        isLoading: false,
        message: "",
        status: false,
      };
    default:
      return state;
  }
};

export default fetchRewardsPointsReducer;
